/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetContentAreaVideosR200ResponseInnerConceptEnum = {
    QuestionStem: 'question_stem',
    RlStandard: 'rl_standard',
    RlSkill: 'rl_skill',
    RlSubSkill: 'rl_sub_skill'
};
/**
 * @export
 */
export const GetContentAreaVideosR200ResponseInnerVideoTypeEnum = {
    Introduction: 'introduction',
    Explanation: 'explanation'
};
/**
 * Check if a given object implements the GetContentAreaVideosR200ResponseInner interface.
 */
export function instanceOfGetContentAreaVideosR200ResponseInner(value) {
    if (!('concept' in value) || value['concept'] === undefined)
        return false;
    if (!('conceptId' in value) || value['conceptId'] === undefined)
        return false;
    if (!('lang' in value) || value['lang'] === undefined)
        return false;
    if (!('videoId' in value) || value['videoId'] === undefined)
        return false;
    if (!('videoType' in value) || value['videoType'] === undefined)
        return false;
    return true;
}
export function GetContentAreaVideosR200ResponseInnerFromJSON(json) {
    return GetContentAreaVideosR200ResponseInnerFromJSONTyped(json, false);
}
export function GetContentAreaVideosR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'concept': json['concept'],
        'conceptId': json['conceptId'],
        'lang': json['lang'],
        'videoId': json['videoId'],
        'videoType': json['videoType'],
    };
}
export function GetContentAreaVideosR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'concept': value['concept'],
        'conceptId': value['conceptId'],
        'lang': value['lang'],
        'videoId': value['videoId'],
        'videoType': value['videoType'],
    };
}
